import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../../../util/assets';
import { getAccountMarketingMaterialSocialPrintTemplateComponent } from './helpers';
import { ALBUM_SUBTYPE } from '../../../../../../../../constants/albums';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    logo_image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }).isRequired,
};

const AccountMarketingMaterialSocialPrintTemplate = ({
  albumFolder,
  account,
}) => {
  const Template = getAccountMarketingMaterialSocialPrintTemplateComponent({
    albumFolder,
  });
  const logoUrl = account?.logo_image?.url;

  return (
    <Fragment>
      {logoUrl && (
        <div className="marketing-material-social-account-logo">
          <img
            src={logoUrl}
            alt=""
            className="marketing-material-social-account-logo-image"
          />
        </div>
      )}

      <Template albumFolder={albumFolder} account={account} />

      {albumFolder.album_subtype === ALBUM_SUBTYPE.CAMPS &&
        albumFolder.has_charity && (
          <div
            style={{
              height: '17.4%',
              top: '4.1%',
              right: '38%',
              width: '24%',
            }}
            className="marketing-material-flyer-camp-scholarship-illustration"
          >
            <img
              src={getAsset('/marketing-material/waldo-scholarship-bubble.png')}
              alt=""
            />
          </div>
        )}
      <img
        src={getAsset('/marketing-material/MARKETING_SOCIAL_TEMPLATE_NEW.png')}
        alt=""
      />
    </Fragment>
  );
};

AccountMarketingMaterialSocialPrintTemplate.propTypes = propTypes;

export default AccountMarketingMaterialSocialPrintTemplate;
